import { render, staticRenderFns } from "./modal-conf.vue?vue&type=template&id=76fb1a33&scoped=true&"
import script from "./modal-conf.vue?vue&type=script&lang=js&"
export * from "./modal-conf.vue?vue&type=script&lang=js&"
import style0 from "./modal-conf.vue?vue&type=style&index=0&id=76fb1a33&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76fb1a33",
  null
  
)

export default component.exports